import React from "react";
import { Modal } from "@geotab/zenith";
import type AppView from "../../../../../../app.view";
import LoginTranslations from "../../../helpers/translations";
import { renderUntilAnswered, TTranslate } from "../../../helpers/renderUntilAnswered";

interface IPasswordUpdatePromptProps {
    translate: TTranslate;
    onAnswer: (isUpdating: boolean) => void;
}

/** A copy of the MyGeotab password policy prompt. */
const PasswordUpdatePrompt: React.FC<IPasswordUpdatePromptProps> = ({ translate, onAnswer }: IPasswordUpdatePromptProps) => (
    <Modal isOpen={true} onClose={() => onAnswer(false)} title={translate(LoginTranslations.PasswordUpdateRecommended)} type="info">
        <div>{translate(LoginTranslations.PasswordUpdateRecommendedMessage)}</div>
        <Modal.TertiaryButton onClick={() => onAnswer(false)}>{translate(LoginTranslations.RemindMeLater)}</Modal.TertiaryButton>
        <Modal.PrimaryButton className="login-primary-button" onClick={() => onAnswer(true)}>{translate(LoginTranslations.UpdatePassword)}</Modal.PrimaryButton>
    </Modal>
);

/** Resolves with whether the driver chose to update their password, which a render failure answers with no. */
export function showPasswordUpdatePrompt(app: AppView): Promise<boolean> {
    return renderUntilAnswered(app, "Password update prompt", false, (answer, translate) => (
        <PasswordUpdatePrompt translate={translate} onAnswer={answer} />
    ));
}

export default PasswordUpdatePrompt;
